import { Outlet } from "react-router-dom";

const UserPage = Outlet

export default UserPage;